<template>
    <div>
        <!-- Project Management Behavior Modal -->
        <div id="projectManagementBehaviorModal" class="modal fade" role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">{{ form.name }}</h4>
                        <button type="button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @keydown="form.errors.clear($event.target.name)">
                            <div v-for="(item, index) in form.project_durations" :key="item.id" class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" :for="item.id"
                                       :class="{'text-red': form.errors.has('project_durations.' + index + '.hours')}">
                                    {{ item.full_description }}
                                </label>
                                <input v-model="item.hours" id="hours" name="hours" type="number" :dusk="'project-duration-input-' + item.id"
                                       @input="form.errors.clear('project_durations.' + index + '.hours')"
                                       class="appearance-none bg-grey-lightest border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full"
                                       :class="{'border-red': form.errors.has('project_durations.' + index + '.hours')}">
                                <div class="text-red text-xs" v-if="form.errors.has('project_durations.' + index + '.hours')">{{
                                    form.errors.get('project_durations.' + index + '.hours') }}
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button @click.prevent="updateProjectManagementBehavior" dusk="project-management-behavior-save-settings"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                            Save
                        </button>
                    </div>
                </div>

            </div>
        </div>

        <div class="text-2xl text-grey-darkest mb-4">{{ member.name }}'s Project Management Behavior Settings</div>
        <div class="text-teal hover:text-teal-dark font-base text-sm mb-4">
            <div @click="goBack" class="flex cursor-pointer">
                <span class="material-icons">chevron_left</span>
                <span>Back</span>
            </div>
        </div>

        <div class="w-full">
            <div class="spark-settings-tabs w-full flex" v-if="project_management_behaviors.length">
                <div class="mt-4 w-1/6">
                    <div class="mb-6 flex-col">
                        <div class="text-sm text-grey-darkest mb-2 pl-2">Project Stages</div>
                        <div v-for="item in project_stages" :key="item.id" class="mb-2">
                            <button class="text-grey-darkest hover:no-underline text-base hover:text-followup-nav cursor-pointer py-1 pl-8"
                            :dusk="'project-stage-' + item.id"
                            :class="currentStage.id === item.id ? 'active' : null" @click="currentStage = item">
                                {{ item.full_description }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="flex-1">
                    <div class="w-full">
                        <div class="tab-content">
                            <table class="text-left w-full border-collapse" v-if="dynamicList.length">
                                <thead>
                                <tr>
                                    <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                                        Name
                                    </th>
                                    <th v-if="project_durations.length > 0" :dusk="'project-duration-table-' + project_durations[0].id"
                                        class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                                        {{ project_durations[0].full_description }}
                                    </th>
                                    <th v-if="project_durations.length > 1" :dusk="'project-duration-table-' + project_durations[1].id"
                                        class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                                        {{ project_durations[1].full_description }}
                                    </th>
                                    <th v-if="project_durations.length > 2" :dusk="'project-duration-table-' + project_durations[2].id"
                                        class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                                        {{ project_durations[2].full_description }}
                                    </th>
                                    <th class="py-2 pl-4 pr-4 bg-grey-lightest border-b border-grey-light"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr @click="editProjectManagementBehavior(item, index)" :key="item.id" class="hover:bg-grey-lighter cursor-pointer"
                                    :dusk="'project-management-behavior-' + item.id"
                                    v-for="(item, index) in dynamicList">
                                    <td class="pl-4 py-2 border-b border-grey-light text-xs">
                                        {{ item.name }}
                                    </td>
                                    <td v-if="project_durations.length > 0" class="pl-4 py-2 border-b border-grey-light text-xs">
                                        {{ item && item.project_durations.length>0 && item.project_durations[0].hours }}
                                    </td>
                                    <td v-if="project_durations.length > 1" class="pl-4 py-2 border-b border-grey-light text-xs">
                                        {{ item && item.project_durations.length>1 && item.project_durations[1].hours }}
                                    </td>
                                    <td v-if="project_durations.length > 2" class="pl-4 py-2 border-b border-grey-light text-xs">
                                        {{ item && item.project_durations.length>2 && item.project_durations[2].hours }}
                                    </td>
                                    <td class="px-4 py-2 border-b border-grey-light text-right">
                                        <button @click.stop="editProjectManagementBehavior(item, index)"
                                                class="material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer">
                                            edit
                                        </button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <h5>No project management behaviors were found.</h5>
            </div>
        </div>
    </div>
</template>

<script>

    import Form from "../../../../utils/form";

    export default {
        props: ['project_management_behaviors', 'project_durations', 'project_stages', 'member', 'team'],

        data() {
            return {
                currentStage: this.project_stages.length ? this.project_stages[0] : null,
                dynamicList: [],
                form: new Form({
                    id: -1,
                    name: '',
                    hours: -1,
                    project_durations: []
                })
            }
        },

        watch: {
            currentStage() {
                this.parseDynamicList();
            }
        },

        created() {
            this.parseDynamicList();
        },

        mounted() {
            $('#projectManagementBehaviorModal').on('hidden.bs.modal', () => {
                this.form.reset();
            })
        },

        methods: {
            goBack() {
                window.location = '/settings/teams/' + this.team.id + '#/membership';
            },

            parseDynamicList() {
                this.dynamicList = _.filter(this.project_management_behaviors, { project_stage_id: this.currentStage.id });
            },

            editProjectManagementBehavior(projectManagementBehavior) {
                this.form.id                = projectManagementBehavior.id;
                this.form.name              = projectManagementBehavior.name;
                this.form.project_durations = projectManagementBehavior.project_durations.map(item => ({ ...item }));

                $("#projectManagementBehaviorModal").modal("show");
            },

            updateProjectManagementBehavior() {
                let self = this;

                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                });

                self.form.put(route('project-management.api.settings.member.project-management-behavior-user-settings.update', {member: self.member.id}))
                    .then(({ data }) => {
                        this.updateDynamicList(data);

                        $("#projectManagementBehaviorModal").modal("hide");

                        Toast.fire({
                            type: 'success',
                            title: data.name + ' updated successfully!'
                        });
                    });
            },

            updateDynamicList(newBehavior) {
                const index = _.findIndex(this.dynamicList, {id: newBehavior.id});
                if (index !== -1) {
                    this.dynamicList.splice(index, 1, newBehavior);
                }
            },
        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
